import { createSlice } from "@reduxjs/toolkit";

const TuristicReportSlice = createSlice({
  name: "turisticPoint",
  initialState: {
    value: [],
  },
  reducers: {
    UpdateValue(state, { payload }) {
      state.value = payload;
    },
    UpdateRow(state, { payload }) {
      state.value.forEach((item) => {
        if (item.id === payload.id) {
          Object.assign(item, payload);
        }
      });
    },
    DeleteRow(state, { payload }) {
      state.value = state.value.filter((item) => item.id !== payload.id);
    },
  },
});

export const selectAll = (state) => state.turisticPoint.value;
export const { DeleteRow, UpdateRow, CreateplansReport, UpdateValue } =
  TuristicReportSlice.actions;
export default TuristicReportSlice.reducer;
